// extracted by mini-css-extract-plugin
export default {"card":"VCard_card__VIXKP","risk":"VCard_risk__QrRl9","col":"VCard_col__nw4wI","img":"VCard_img__gK9MV"};